import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  premiumGradeNotice: {
    id: 'product_jp_reviews_premium_grade_notice',
    defaultMessage:
      'As of April 2026, the Premium grade includes only devices with 100% battery capacity. \nReviews from before this change are also displayed.',
  },
} as Record<string, I18nDefinition>
